import { i18n } from '@/i18n';
import { DocumentType } from '@/model/inventory';
import { useAccountStore } from '@/stores/AccountStore/AccountStore';
import { useInventoryStore } from '@/stores/InventoryStore/InventoryStore';
import { type NeonSearchOption } from '@arcual/lib-app-neon';
import {
  type ArcualAccountProfile,
  type ArcualInventoryItem,
  ArcualItemCategory,
  ArcualItemType,
} from '@arcual/lib-app-platform';

const { t } = i18n.global;

const getAccountById = async (id?: string, account?: ArcualAccountProfile) =>
  account || (id ? useAccountStore().getAccountById(id) : undefined);

/**
 * enrich inventory item with reference data
 * @param item
 */
export const enrichInventoryItem = async (item: ArcualInventoryItem) => {
  item.seller = await getAccountById(item.sellerProfileId, item.seller);
  item.owner = await getAccountById(item.ownerProfileId, item.owner);
  item.creator = await getAccountById(item.originatorProfileId, item.creator);

  if (!item.actions) {
    item.actions = await useInventoryStore().getItemActions(item.id);
  }

  if (
    (item.itemType === ArcualItemType.EDITION || item.itemType === ArcualItemType.ARTIST_PROOF) &&
    item.childMetadata &&
    !item.childMetadata?.volume &&
    item.masterMetadata
  ) {
    item.childMetadata.volume =
      item.itemType === ArcualItemType.EDITION
        ? item.masterMetadata.editionsVolume
        : item.masterMetadata.artistProofsVolume;
  }
};

// TODO: these should be translated
export const categories = [
  { label: t('platform.app.gallery.artworks.typePlaceholder'), key: '' },
  { label: ArcualItemCategory.PAINTING, key: 'Painting' },
  { label: ArcualItemCategory.PRINT, key: 'Prints and editions' },
  { label: ArcualItemCategory.WORK_ON_PAPER, key: 'Work on paper' },
  { label: ArcualItemCategory.SCULPTURE, key: 'Sculpture' },
  { label: ArcualItemCategory.PHOTOGRAPHY, key: 'Photography' },
  { label: ArcualItemCategory.INSTALLATION, key: 'Installation' },
  { label: ArcualItemCategory.VIDEO, key: 'Video' },
  { label: ArcualItemCategory.DIGITAL_ART, key: 'Digital art' },
  { label: ArcualItemCategory.OTHER, key: 'Other' },
];

export const units: Array<NeonSearchOption> = [
  { label: 'cm', key: 'cm' },
  { label: 'inch', key: 'inch' },
  { label: 'px', key: 'px' },
  { label: 'hh:mm:ss', key: 'duration' },
  { label: 'volume m³', key: 'volumeCubicMeters' },
  { label: 'volume ft³', key: 'volumeCubicFeet' },
  { label: 'other', key: 'other' },
];

export const documentTypes: Array<NeonSearchOption> = Object.values(DocumentType).map((type) => ({
  label: type,
  key: type,
}));
